import { Route, Switch } from "wouter";
import { ProtectedRoute } from "./components/ProtectedRoute.tsx";
import AcceptInvite from "./pages/AcceptInvite.tsx";
import Agenda from "./pages/Agenda.tsx";
import Devis from "./pages/Devis.tsx";
import Audit from "./pages/Audit.tsx";
import EmailOutbox from "./pages/EmailOutbox.tsx";
import BankAccounts from "./pages/BankAccounts.tsx";
import BankCategorias from "./pages/BankCategorias.tsx";
import BankExtratos from "./pages/BankExtratos.tsx";
import BankImport from "./pages/BankImport.tsx";
import BankReconciliacao from "./pages/BankReconciliacao.tsx";
import BankSocio from "./pages/BankSocio.tsx";
import Controle from "./pages/Controle.tsx";
import Customers from "./pages/Customers.tsx";
import CustomerDetail from "./pages/CustomerDetail.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import DossierDetail from "./pages/DossierDetail.tsx";
import Dossiers from "./pages/Dossiers.tsx";
import Empresas from "./pages/Empresas.tsx";
import Intermediarios from "./pages/Intermediarios.tsx";
import RelatorioCaGap from "./pages/RelatorioCaGap.tsx";
import Fiscal from "./pages/Fiscal.tsx";
import HailParcs from "./pages/HailParcs.tsx";
import HailParcDetail from "./pages/HailParcDetail.tsx";
import FiscalBilan from "./pages/FiscalBilan.tsx";
import FiscalBudget from "./pages/FiscalBudget.tsx";
import FiscalBudgetCompare from "./pages/FiscalBudgetCompare.tsx";
import ImportEdsp from "./pages/ImportEdsp.tsx";
import FiscalEntries from "./pages/FiscalEntries.tsx";
import FiscalResultat from "./pages/FiscalResultat.tsx";
import FiscalSeuil from "./pages/FiscalSeuil.tsx";
import FiscalSig from "./pages/FiscalSig.tsx";
import FiscalTva from "./pages/FiscalTva.tsx";
import PurchaseInvoices from "./pages/PurchaseInvoices.tsx";
import Suppliers from "./pages/Suppliers.tsx";
import ForgotPassword from "./pages/ForgotPassword.tsx";
import Invites from "./pages/Invites.tsx";
import Landing from "./pages/Landing.tsx";
import Login from "./pages/Login.tsx";
import NotFound from "./pages/NotFound.tsx";
import PagamentosTecnicos from "./pages/PagamentosTecnicos.tsx";
import ChantierPortal from "./pages/ChantierPortal.tsx";
import ClientPortal from "./pages/ClientPortal.tsx";
import ChantierDetail from "./pages/ChantierDetail.tsx";
import Chantiers from "./pages/Chantiers.tsx";
import TechnicianPortal from "./pages/TechnicianPortal.tsx";
import ProformaDetail from "./pages/ProformaDetail.tsx";
import ProformaNew from "./pages/ProformaNew.tsx";
import Proformas from "./pages/Proformas.tsx";
import Faturas from "./pages/Faturas.tsx";
import FaturaNova from "./pages/FaturaNova.tsx";
import FinanceApp from "./pages/financeiro/FinanceApp.tsx";
import Relatorio from "./pages/Relatorio.tsx";
import Conta from "./pages/Conta.tsx";
// F13.2 — Design System interno (apenas em DEV, ver Switch abaixo).
import DesignSystem from "./pages/DesignSystem.tsx";
import ResetPassword from "./pages/ResetPassword.tsx";
import AboutPage from "./pages/settings/AboutPage.tsx";
import TeamNotices from "./pages/TeamNotices.tsx";
import Tasks from "./pages/Tasks.tsx";
import Technicians from "./pages/Technicians.tsx";
import TechnicianDetail from "./pages/TechnicianDetail.tsx";
import TechnicianSignup from "./pages/TechnicianSignup.tsx";
import Users from "./pages/Users.tsx";
import Vehicles from "./pages/Vehicles.tsx";

export default function App() {
  return (
    <Switch>
      <Route path="/" component={Landing} />
      <Route path="/login" component={Login} />
      <Route path="/esqueci-senha" component={ForgotPassword} />
      <Route path="/redefinir-senha" component={ResetPassword} />
      <Route path="/aceitar-convite" component={AcceptInvite} />
      {/* F-tech-signup — porta PÚBLICA do técnico: cai na fila, não cria conta. */}
      <Route path="/cadastro-tecnico" component={TechnicianSignup} />
      <Route path="/dashboard">
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      </Route>
      <Route path="/conta">
        <ProtectedRoute>
          <Conta />
        </ProtectedRoute>
      </Route>
      <Route path="/usuarios">
        {/* F-admin-usuarios (CEO 2026-11-02) — o Administrador também gere usuários. */}
        <ProtectedRoute requireAdmin>
          <Users />
        </ProtectedRoute>
      </Route>
      <Route path="/convites">
        <ProtectedRoute requireSuperAdmin>
          <Invites />
        </ProtectedRoute>
      </Route>
      <Route path="/audit">
        <ProtectedRoute requireAdmin>
          <Audit />
        </ProtectedRoute>
      </Route>
      <Route path="/emails">
        <ProtectedRoute requireAdmin>
          <EmailOutbox />
        </ProtectedRoute>
      </Route>
      <Route path="/settings/about">
        <ProtectedRoute>
          <AboutPage />
        </ProtectedRoute>
      </Route>
      {/* F-recados-equipe (CEO 2026-10-28) — Administrador/Super Admin. */}
      <Route path="/recados">
        <ProtectedRoute>
          <TeamNotices />
        </ProtectedRoute>
      </Route>
      {/* F-tarefas (CEO 2026-10-29) — todos veem as suas; Admin cria. */}
      <Route path="/tarefas">
        <ProtectedRoute>
          <Tasks />
        </ProtectedRoute>
      </Route>
      <Route path="/clientes">
        <ProtectedRoute>
          <Customers />
        </ProtectedRoute>
      </Route>
      <Route path="/clientes/:id">
        <ProtectedRoute>
          <CustomerDetail />
        </ProtectedRoute>
      </Route>
      <Route path="/veiculos">
        <ProtectedRoute>
          <Vehicles />
        </ProtectedRoute>
      </Route>
      <Route path="/tecnicos">
        <ProtectedRoute>
          <Technicians />
        </ProtectedRoute>
      </Route>
      <Route path="/tecnicos/:id">
        <ProtectedRoute>
          <TechnicianDetail />
        </ProtectedRoute>
      </Route>
      <Route path="/intermediarios">
        <ProtectedRoute>
          <Intermediarios />
        </ProtectedRoute>
      </Route>
      <Route path="/dossiers">
        <ProtectedRoute>
          <Dossiers />
        </ProtectedRoute>
      </Route>
      <Route path="/import/edsp">
        <ProtectedRoute>
          <ImportEdsp />
        </ProtectedRoute>
      </Route>
      {/* F-tech-portal — portal do técnico (papel `technician`; fora do ErpShell). */}
      <Route path="/devis">
        <ProtectedRoute>
          <Devis />
        </ProtectedRoute>
      </Route>
      <Route path="/agenda">
        <ProtectedRoute>
          <Agenda />
        </ProtectedRoute>
      </Route>
      <Route path="/chantiers/:id">
        <ProtectedRoute>
          <ChantierDetail />
        </ProtectedRoute>
      </Route>
      <Route path="/chantiers">
        <ProtectedRoute>
          <Chantiers />
        </ProtectedRoute>
      </Route>
      <Route path="/cliente">
        <ProtectedRoute requireClient>
          <ClientPortal />
        </ProtectedRoute>
      </Route>
      <Route path="/chantier">
        <ProtectedRoute requireManager>
          <ChantierPortal />
        </ProtectedRoute>
      </Route>
      <Route path="/portal">
        <ProtectedRoute requireTechnician>
          <TechnicianPortal />
        </ProtectedRoute>
      </Route>
      <Route path="/dossiers/:id">
        <ProtectedRoute>
          <DossierDetail />
        </ProtectedRoute>
      </Route>
      <Route path="/proformas">
        <ProtectedRoute>
          <Proformas />
        </ProtectedRoute>
      </Route>
      <Route path="/proformas/nova">
        <ProtectedRoute>
          <ProformaNew />
        </ProtectedRoute>
      </Route>
      <Route path="/proformas/:id">
        <ProtectedRoute>
          <ProformaDetail />
        </ProtectedRoute>
      </Route>
      <Route path="/faturas/nova">
        <ProtectedRoute>
          <FaturaNova />
        </ProtectedRoute>
      </Route>
      <Route path="/faturas">
        <ProtectedRoute>
          <Faturas />
        </ProtectedRoute>
      </Route>
      <Route path="/contas-bancarias">
        <ProtectedRoute>
          <BankAccounts />
        </ProtectedRoute>
      </Route>
      <Route path="/banco">
        <ProtectedRoute>
          <BankExtratos />
        </ProtectedRoute>
      </Route>
      <Route path="/banco/importar">
        <ProtectedRoute>
          <BankImport />
        </ProtectedRoute>
      </Route>
      <Route path="/banco/categorias">
        <ProtectedRoute>
          <BankCategorias />
        </ProtectedRoute>
      </Route>
      <Route path="/banco/reconciliacao">
        <ProtectedRoute>
          <BankReconciliacao />
        </ProtectedRoute>
      </Route>
      <Route path="/banco/socio">
        <ProtectedRoute>
          <BankSocio />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal">
        <ProtectedRoute>
          <Fiscal />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/resultat">
        <ProtectedRoute>
          <FiscalResultat />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/sig">
        <ProtectedRoute>
          <FiscalSig />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/seuil">
        <ProtectedRoute>
          <FiscalSeuil />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/bilan">
        <ProtectedRoute>
          <FiscalBilan />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/budget">
        <ProtectedRoute>
          <FiscalBudget />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/budget/compare">
        <ProtectedRoute>
          <FiscalBudgetCompare />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/entries">
        <ProtectedRoute>
          <FiscalEntries />
        </ProtectedRoute>
      </Route>
      <Route path="/fiscal/tva">
        <ProtectedRoute>
          <FiscalTva />
        </ProtectedRoute>
      </Route>
      <Route path="/fornecedores">
        <ProtectedRoute>
          <Suppliers />
        </ProtectedRoute>
      </Route>
      <Route path="/compras">
        <ProtectedRoute>
          <PurchaseInvoices />
        </ProtectedRoute>
      </Route>
      <Route path="/pagamentos-tecnicos">
        <ProtectedRoute>
          <PagamentosTecnicos />
        </ProtectedRoute>
      </Route>
      <Route path="/controle">
        <ProtectedRoute>
          <Controle />
        </ProtectedRoute>
      </Route>
      <Route path="/relatorio">
        <ProtectedRoute>
          <Relatorio />
        </ProtectedRoute>
      </Route>
      <Route path="/relatorio-ca">
        <ProtectedRoute>
          <RelatorioCaGap />
        </ProtectedRoute>
      </Route>
      <Route path="/empresas">
        <ProtectedRoute>
          <Empresas />
        </ProtectedRoute>
      </Route>
      {/* F-parc — Parc Grêle (lado admin). */}
      <Route path="/parc-grele">
        <ProtectedRoute requireAdmin>
          <HailParcs />
        </ProtectedRoute>
      </Route>
      <Route path="/parc-grele/:id">
        <ProtectedRoute requireAdmin>
          <HailParcDetail />
        </ProtectedRoute>
      </Route>
      {/* StormFin (Tesouraria) — F-finance-viewer-access: super admin (total) OU
          viewer/sócio (leitura). Admin de empresa e user comum NÃO acessam.
          Guard de rota + backend (leituras financeReadProcedure, escritas
          superAdminProcedure). */}
      <Route path="/financeiro" nest>
        <ProtectedRoute requireFinance>
          <FinanceApp />
        </ProtectedRoute>
      </Route>
      {/* F13.2 — Rota de referência visual interna, apenas em DEV.
          NÃO requer auth (página estática, idêntica em qualquer ambiente). */}
      {import.meta.env.DEV && <Route path="/design-system" component={DesignSystem} />}
      <Route component={NotFound} />
    </Switch>
  );
}
